import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    thirdPartyCodeWrapper: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: 'relative',
        cursor: "pointer",
    },
    thirdPartyCode: {
        color: theme.palette.grey.grey400,
        backgroundColor: theme.palette.grey.grey100 + "80", // 50% opacity on color
        borderRadius: "16px",
        padding: "0 1rem",
        lineHeight: "300%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineClamp: 1,
        boxOrient: "vertical",
        display: "-webkit-box",
        wordBreak: "break-all",
        fontSize: "0.8125rem",
        width: "100%"
    },
    thirdPartyCodeIcon:{
        backgroundColor: theme.palette.grey.grey100,
        borderRadius: "16px",
        padding: "0.35rem",
        marginLeft: "1rem",
    },
    thirdPartieIdContent: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineClamp: 1,
        boxOrient: "vertical",
        display: "-webkit-box",
        wordBreak: "break-all",
        fontSize: "0.8125rem",
        backgroundColor: "#F2F3F7",
        color: "#656575",
        fontWeight: 600,
        padding: "4px 10px",
        borderRadius: "16px",
    },
    thirdPartieCodeWrapper: {
        position: "relative",
        cursor: "pointer",
    }
}));

export default useStyles;
